import { get_fa, put_verifyItem } from "@/api/uaapi/account";
import { get_countryInfos, get_kycGetRealAuthInfo, getUserInfo, get_getFa } from "@/api/uaapi/user";
import { Cookie, Storage } from "@xt/xtbase";
import { intercept, makeAutoObservable, observable } from "mobx";
import { waitRes, setHeader } from "utils/axios";
export enum FaSceneDictEnum {
  /**绑定防钓鱼码 */
  ANTI_FISHING_CODE__BIND = "ANTI_FISHING_CODE__BIND",
  /**更改防钓鱼码 */
  ANTI_FISHING_CODE__MODIFY = "ANTI_FISHING_CODE__MODIFY",
  /**创建API */
  API_KEY__CREATE = "API_KEY__CREATE",
  /**更改API */
  API_KEY__MODIFY = "API_KEY__MODIFY",
  /** 绑定邮箱*/
  EMAIL__BIND = "EMAIL__BIND",
  /**更改邮箱 */
  EMAIL__MODIFY = "EMAIL__MODIFY",
  /**绑定谷歌验证器 */
  GA__BIND = "GA__BIND",
  /**解绑谷歌验证器 */
  GA__UNBIND = "GA__UNBIND",
  /**绑定手机 */
  MOBILE__BIND = "MOBILE__BIND",
  /**更改手机 */
  MOBILE__MODIFY = "MOBILE__MODIFY",
  /**登录 */
  LOGIN = "LOGIN",
  /**更改登录密码 */
  LOGIN_PWD__MODIFY = "LOGIN_PWD__MODIFY",
  /**重置登录密码 */
  LOGIN_PWD__RESET = "LOGIN_PWD__RESET",
  // 禁用
  FA_USER_DISABLE = "FA_USER_DISABLE",
  // 启用
  FA_USER_ENABLE = "FA_USER_ENABLE",
}
// 老的用户信息（后续废弃）
interface UserInfoProps extends ObjAny {
  accountId?: number | string;
  authLevel?: number;
  code?: number;
  countryCode?: string;
  email?: string;
  emailAuth?: number;
  emailAuthStatus?: number;
  emailAuthTime?: string;
  existSubAccount?: number;
  futuresOpenStatus?: number;
  gaAuthTime?: string;
  googleAuth?: number;
  googleAuthStatus?: number;
  initialAuth?: number;
  kycAuthCountryId?: number;
  lastLoginIp?: string;
  lastLoginTime?: string;
  loginAuth?: number;
  loginPwd?: string;
  loginPwdLevel?: number;
  miningOpenStatus?: number;
  mobile?: string;
  mobileAuth?: number;
  mobileAuthStatus?: number;
  mobileAuthTime?: string;
  openId?: string;
  realAuth?: number;
  realName?: string;
  recommendCode?: string;
  recommendId?: string;
  regCountryId?: number;
  regTime?: string;
  safePwd?: string;
  safePwdLevel?: number;
  signType?: string;
  syncUserFlag?: number;
  antiFishingCode?: string;
  /** 1=主账户，2=子账户 */
  userAccountLevel?: number;
  accountLevel?: number;
  userId?: number | string;
  userIdStr?: string;
  userName?: string;
  userVipLevel?: number;
  userVipLevelName?: string;
  vipLevel?: number;
  // 头像昵称字段
  headImgUrl?: string;
  nickName?: string;
  isModifyImgOrNick?: string;
  imgTimesRemaining?: number;
  nickTimesRemaining?: number;
}
interface AuthInfo {
  country: {
    des: string;
    code: string;
    nationalFlagIcon: string;
    name: string;
    id: number;
    nameEn: string;
    shortName: string;
    xtId: number;
  };
  isXt: number;
  userAuthInfoVo: {
    birthday: number;
    realName: string;
    advanceAuthStatus: number;
    verifyCode: number;
    countryCode: string;
    cardType: number;
    failReason: string;
    countryId: string;
    status: number;
  };
  /**是否kyc的黑名单 0否 1是 */
  isKycBlack: number;
}
/**国家list每一项类型 */
export interface CountryProps {
  code: string;
  des?: string;
  id: number;
  isKyc?: number;
  name: string;
  nameEn: string;
  nationalFlagIcon: string;
  shortName: string;
  xtId?: number;
}

export interface CountryInfosProps {
  countryList?: CountryProps[];
  defaultCountryId?: number;
  ipCountryCode?: string;
  ipCountryId?: number;
  userCountryCode?: string;
}
export type UserInfoType = WithNull<UserInfoProps>;

export interface FaItemProps {
  type: "EMAIL" | "MOBILE" | "GA";
  receiveAddr: string;
  priority: number;
}
export interface FaCheckProps {
  faCheckId: string;
  /**从items中选择几个验证项从优先级高开始 */
  validNumber: number;
  faItems: FaItemProps[];
}

export interface IFaDataItem {
  bind: number;
  enable: number;
  type: string;
}

interface StateProps {
  isLogin: boolean;
  token: string;
  userInfo: UserInfoType;
  canEnterprise: boolean;
  authInfo: AuthInfo;
  countryInfo: CountryInfosProps;
  countryList: CountryInfosProps["countryList"];
  faCheckData: FaCheckProps;
  faData: IFaDataItem[];
}

const user = makeAutoObservable(
  {
    isLogin: false as StateProps["isLogin"], //用户是否登录
    token: "" as StateProps["token"], //用户token
    userInfo: null as StateProps["userInfo"], //用户信息
    /** 认证信息 */
    authInfo: { country: {}, userAuthInfoVo: {} } as StateProps["authInfo"],
    /** 是否可以进行企业认证 */
    canEnterprise: false as StateProps["canEnterprise"],
    /** 国家代码信息 */
    countryInfo: {} as StateProps["countryInfo"],
    /**国家代码list */
    countryList: [] as StateProps["countryList"],
    /**验证项数据 */
    faCheckData: { faCheckId: "", validNumber: 0, faItems: [] } as StateProps["faCheckData"],

    // 2fa配置项启用禁用数据
    faData: [],
    get faEnableLen(): number {
      return this.faData.filter((item: any) => !!item.enable && item.type !== "PASSKEY").length;
    }, //fa启动的个数，不包含通行密钥

    /** 是否是子账户 */
    get isSubAcc(): boolean {
      return !!(this.userInfo && this.userInfo.userAccountLevel === 2);
    },
    /**不是子账户 */
    get notSub(): boolean {
      return !(this.userInfo && this.userInfo.userAccountLevel == 2);
    },
    /**是否启用谷歌验证器 */
    get googleAuth(): boolean {
      return !!this.userInfo && !!this.userInfo.googleAuth;
    },
    /**是否已经绑定邮箱 */
    get emailAuth(): boolean {
      return !!this.userInfo && !!this.userInfo.email;
    },
    /**是否已经绑定手机 */
    get mobileAuth(): boolean {
      return !!this.userInfo && !!this.userInfo.mobile;
    },
    /** 高级认证状态 0为未提交，1审核中，2审核通过，3审核不通过*/
    get realAuth(): number {
      return this.authInfo.userAuthInfoVo ? parseFloat(this.authInfo.userAuthInfoVo.advanceAuthStatus + "") || 0 : -1;
    },

    /** 初级认证状态 0为未提交，1审核中，2审核通过，3审核不通过(可以再次提交)
     * 4 审核不通过(无法提交) */
    get initialAuth(): number {
      return this.authInfo.userAuthInfoVo ? parseFloat(this.authInfo.userAuthInfoVo.advanceAuthStatus + "") || 0 : -1;
    },

    /** 是否通过高级认证 */
    get isRealAuth(): boolean {
      return this.realAuth === 2;
    },

    /**是否通过实名认证 */
    get isInitialAuth(): boolean {
      return this.initialAuth === 2;
    },

    /**0未认证，1初级认证 2高级认证 */
    get authLevel(): number {
      if (this.isInitialAuth) return 2;
      return 0;
      // return state.userInfo ? parseFloat(state.userInfo.authLevel) : ''
    },
    get userAuthLevel() {
      return this.userInfo ? parseFloat(this.userInfo.authLevel) : 0;
    },
    // 是否设置防钓鱼码
    get antiFishingCode(): string {
      return this.userInfo?.antiFishingCode || "";
    },
    /** 有效的faList */
    get faList() {
      const { validNumber = 0, items = [] } = this.faCheckData;
      return items.slice(0, validNumber) as FaItemProps[];
    },
    /**是否email验证 */
    get emailFa() {
      return this.faList.find((faItem: FaItemProps) => faItem.type === "EMAIL") as FaItemProps;
    },
    /**是否mobile验证 */
    get mobileFa() {
      return this.faList.find((faItem: FaItemProps) => faItem.type === "MOBILE") as FaItemProps;
    },
    /**是否google验证 */
    get googleFa() {
      return this.faList.find((faItem: FaItemProps) => faItem.type === "GA") as FaItemProps;
    },
    /**邮箱地址 */
    get email(): string {
      return this.emailFa?.receiveAddr || "";
    },
    /**手机号 */
    get mobile(): string {
      return this.mobileFa?.receiveAddr || "";
    },
    updateState(payload: Partial<StateProps>) {
      for (const va in payload) {
        this[va] = payload[va];
      }
    },
    /**重置认证状态 */
    setAuthStatus(status: number) {
      const userAuthInfoVo = this.authInfo.userAuthInfoVo;
      userAuthInfoVo.status = status;
      this.authInfo = { ...this.authInfo, userAuthInfoVo };
    },
    /**重置认证状态高级 */
    setAdvancedAuthStatus(status: number) {
      const userAuthInfoVo = this.authInfo.userAuthInfoVo;
      userAuthInfoVo.advanceAuthStatus = status;
      this.authInfo = { ...this.authInfo, userAuthInfoVo };
    },
    /** 设置验证项 */
    setFaCheckDataItem(data: FaCheckProps) {
      this.faCheckData = data;
    },
    /**
     * 重置用户状态为未登录状态
     */
    resetStatusToNotLogin() {
      this.token = "";
      this.userInfo = {};
      setHeader({ token: "" });
      Storage.remove("token");
      Cookie.remove("token");
      Storage.remove("bindGoogleTip");
      Storage.remove("otcFiat");
    },

    get faDatas() {
      if (this.faData.length) {
        return this.faData;
      }
      this.getFaData().then((res) => {
        return res;
      });
    },
    /**
     * 获取2fa启用禁用信息
     */
    async getFaData() {
      const { data, err } = await waitRes(get_getFa, {});
      if (!err) this.updateState({ faData: data });
      return data;
    },

    /**
     * 获取更新用户信息
     */
    async getUserInfo() {
      const { data, err } = await waitRes(getUserInfo, {});
      if (!err) this.updateState({ userInfo: data });
      return this.userInfo;
    },

    /**
     * 获取用户认证信息
     */
    async getAuthInfo() {
      const { data, err } = await waitRes(get_kycGetRealAuthInfo, {});
      if (!err) this.updateState({ authInfo: data });
      return data;
    },

    /**
     * 获取国家代码信息
     */
    async getCountryInfo(userBehavior = "KYC_AUTH") {
      if (Object.keys(this.countryInfo).length) {
        return { data: this.countryInfo };
      }
      const { data, err }: { data: CountryInfosProps; err?: string } = await waitRes(get_countryInfos, "", { params: { userBehaviorEnum: userBehavior } });
      if (!err) {
        this.updateState({ countryInfo: data, countryList: data.countryList || [] });
      }
      return { data, err };
    },

    /**
     * 获取验证项
     */
    async getVerifyItems(faSceneDict: FaSceneDictEnum, isNew?: boolean) {
      if (isNew) {
        const { data, err }: { data: FaCheckProps; err?: string } = await waitRes(put_verifyItem, {
          params: {
            faSceneDict,
          },
          errorPop: true,
        });
        if (!err && data) {
          data.faItems?.sort((a, b) => b.priority - a.priority);
          this.faCheckData = data;
        }
        return this.faCheckData;
      } else {
        return this.faCheckData;
      }
    },
  },
  {},
  {
    autoBind: true,
    deep: false,
  }
);

export default user;
